import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import toast from 'shared/utils/toast';
import { IMedicalServiceEtlField } from '../types';
import MedicalServiceEtlFieldForm from '../components/MedicalServiceEtlFieldForm';
import { medicalServiceEtlFieldService } from '../api/medical-service-etl-field.service';

const initTranscode = {
  id: null,
  field_from: null,
  field_to: null,
  field_to_description: null,
  transcode: null
};

export const CreateMedicalServiceEtlFields = () => {
  const translationPrefix = 'pages.extra-field-transcode.new';

  const { t } = useTranslation();

  const createTranscode = async (values) => {
    const field: IMedicalServiceEtlField = {
      id: null,
      field_from: values.field_from,
      field_to: values.field_to.code,
      field_to_description: values.field_to.description,
      transcode: values.transcode
    };
    medicalServiceEtlFieldService.add(field).then((res) => {
      if (res) toast.success('Transcodifica aggiunta con successo.');
    });
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <MedicalServiceEtlFieldForm transcode={initTranscode} onSubmit={createTranscode} />
    </TenantPage>
  );
};

export default CreateMedicalServiceEtlFields;
